import React from 'react';
import { LeadDistributor } from './pages/LeadDistributor';
export function App() {
  return <LeadDistributor data-id="element-0" />;
}